// user error codes
export const ERROR_EMAIL_NOT_VERIFIED = 'email_not_verified';
export const ERROR_INVALID_USERNAME_OR_PASSWORD = 'invalid_username_password';
export const ERROR_EMAIL_ADDRESS_IN_USE = 'email_address_in_use';
export const ERROR_INVALID_ACCOUNT = 'invalid_account';
export const ERROR_INVALID_USER = 'invalid_user';
export const ERROR_PASSWORD_RESET_FAILED = 'password_reset_failed';
